import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import { MenuManagementBrandMenuListParams } from '@/services/BrandMenu/hooks';
import { MenuManagementBrandMenuHourCreateParams } from '@/services/BrandMenuHour/hooks/create/useMenuManagementCreateBrandMenuHour';
import { BrandMenuHourListResponse } from '@/services/BrandMenuHour/hooks/list/useMenuManagementBrandMenuHourList';
import {
  MenuManagementBrandMenuHourSearchParams,
  SearchBrandMenuHourResponse,
} from '@/services/BrandMenuHour/hooks/search/useMenuManagementBrandMenuHourSearch';
import { ShowBrandMenuHourResponse } from '@/services/BrandMenuHour/hooks/show/useMenuManagementBrandMenuHourShow';
import { MenuManagementBrandMenuHourUpdateParams } from '@/services/BrandMenuHour/hooks/update/useMenuManagementUpdateBrandMenuHour';
import { menuManagementListQueryParams } from '@/services/Service/MenuManagementList';

export type SearchItem = {
  id: string;
  name: string;
};

interface Interface {
  create: (params: MenuManagementBrandMenuHourCreateParams) => Promise<void>;
  list: (
    params: MenuManagementBrandMenuListParams
  ) => Promise<BrandMenuHourListResponse>;
  // show: (id: string) => Promise<ShowMenuResponse>;
  update: (
    id: string,
    params: MenuManagementBrandMenuHourUpdateParams
  ) => Promise<void>;
  // delete: (id: string) => Promise<void>;
  search: (
    params: MenuManagementBrandMenuHourSearchParams
  ) => Promise<SearchBrandMenuHourResponse[]>;
}

export class MenuManagementBrandMenuHourService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async create(
    params: MenuManagementBrandMenuHourCreateParams
  ): Promise<void> {
    await this.restClient.post<MenuManagementBrandMenuHourCreateParams, void>(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-menu-hours` as const,
      params
    );
  }

  public async list(
    params: MenuManagementBrandMenuListParams
  ): Promise<BrandMenuHourListResponse> {
    const query = menuManagementListQueryParams(params);
    return await this.restClient.get<BrandMenuHourListResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-menu-hours${query}` as const
    );
  }

  public async show(id: string): Promise<ShowBrandMenuHourResponse> {
    return await this.restClient.get<ShowBrandMenuHourResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-menu-hours/${id}` as const
    );
  }

  public async update(
    id: string,
    params: MenuManagementBrandMenuHourUpdateParams
  ): Promise<void> {
    return await this.restClient.patch(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-menu-hours/${id}` as const,
      params
    );
  }

  public async delete(id: string): Promise<void> {
    return await this.restClient.delete(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-menu-hours/${id}` as const
    );
  }

  public async search(
    params: MenuManagementBrandMenuHourSearchParams
  ): Promise<SearchBrandMenuHourResponse[]> {
    const query =
      `?associate_brand_id=${params.associate_brand_id.toString()}` as const;

    return await this.restClient.get(
      `${TABLET_API_ORIGIN}/dashboard-api/brand-menu-hours/search${query}` as const
    );
  }
}
